import { getCompany, updateCompany } from '../../shared/services/apiService';

// ── Load company settings ─────────────────────────────────────────────────────
export const loadCompany = async () => {
  const res = await getCompany();
  const c   = res.data.data;
  return {
    company_name:  c.company_name  || '',
    domain:        c.domain        || '',
    company_url:   c.company_url   || '',
    logo_url:      c.logo_url      || '',
    favicon_url:   c.favicon_url   || '',
    primary_color: c.primary_color || '#2563eb',
    timezone:      c.timezone      || 'UTC',
  };
};

// ── Persist company settings changes (returns updated company) ───────────────
export const saveCompany = async (formData) => {
  const res = await updateCompany(formData);
  const c   = res.data.data;
  return {
    company_name:  c.company_name  || '',
    domain:        c.domain        || '',
    company_url:   c.company_url   || '',
    logo_url:      c.logo_url      || '',
    favicon_url:   c.favicon_url   || '',
    primary_color: c.primary_color || '#2563eb',
    timezone:      c.timezone      || 'UTC',
  };
};
